'use client'

import { motion } from 'framer-motion'

export function VentureStudio() {
  return (
    <section id="venture-studio" className="bg-[#1b184f] py-16 md:py-24 scroll-mt-16">
      <div className="container max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-[#8b6cff] text-lg font-anuphan mb-4"
        >
          The Ultimate Partnership
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-white text-3xl md:text-[48px] font-normal leading-[1.1] font-gendy mb-6"
        >
          The Venture Studio
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-white text-xl md:text-[30px] leading-[1.4] font-anuphan mb-4 max-w-[900px]"
        >
          Build the platform. Own the market.
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="text-[#bdbdbd] text-lg md:text-[22px] leading-[1.5] font-anuphan mb-8 max-w-[800px]"
        >
          For the visionary founder who uncovers an automation or platform idea massive enough to stand on its own. We transition from consultants to co-founders — aligning our success entirely with yours.
        </motion.p>

        <div className="grid sm:grid-cols-3 gap-6 mb-12">
          {[
            { title: 'Engineering', desc: 'Top-tier AI architecture and product development. We provide the technical execution to build enterprise-grade software.' },
            { title: 'Equity Alignment', desc: 'We take an equity stake in the NewCo. We don\'t just build for you — we build with you.' },
            { title: 'Full Ownership', desc: 'You own the platform, the IP, and the market position. Zero ambiguity.' },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-white/[0.05] border border-[#544ae8]/30 rounded-[20px] p-6"
            >
              <p className="text-white font-semibold font-anuphan mb-2">{item.title}</p>
              <p className="text-[#8a8f9e] text-sm font-anuphan leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="text-[#bdbdbd] text-lg font-anuphan mb-8"
        >
          Every Venture Studio engagement is unique. Let&apos;s explore what&apos;s possible.
        </motion.p>

        <p className="text-[#8a8f9e] text-sm font-anuphan italic mb-8 max-w-[700px]">
          Platform development and enterprise-scale automations fall outside the scope of The Build and The Academy. Let&apos;s discuss building your legacy.
        </p>

        <a
          href="mailto:alex@behmn.com?subject=Venture%20Studio%20Inquiry%20%E2%80%94%20Let%E2%80%99s%20Build%20Something&body=Hi%20Alex%2C%0A%0AI%E2%80%99m%20interested%20in%20the%20Venture%20Studio%20%E2%80%94%20I%20have%20a%20platform%20or%20automation%20idea%20I%E2%80%99d%20like%20to%20explore.%0A%0AHere%E2%80%99s%20the%20vision%3A%0A%0A%5BYour%20name%2C%20the%20idea%2C%20and%20where%20you%20are%20today%5D%0A%0ALooking%20forward%20to%20discussing."
          className="inline-block border border-[#8b6cff]/50 rounded-[100px] px-10 py-4 text-[#8b6cff] text-lg font-anuphan hover:bg-[#8b6cff]/10 transition-colors"
        >
          Discuss Your Vision
        </a>
      </div>
    </section>
  )
}
